import * as Storage from "./storage";
import { getBearerToken, getUserId, isLoggedIn, logout as logoutPlatform } from "@cj-platform/authentication-browser";

export const getEmailAddress = async (authConfig) => {
    const memberUser = await fetchMemberUser(authConfig)
    delete memberUser.companies;
    memberUser.emailAddress = memberUser.emailAddress.toLowerCase().trim()
    Storage.set(Storage.MEMBER_USER, btoa(JSON.stringify(memberUser)));
}

const logout = () => {
    Storage.remove(Storage.MEMBER_USER);
    logoutPlatform();
}

const isAuthenticated = async () => {
    return await isLoggedIn();
};

const getUser = () => {
    let memberUserValue = Storage.get(Storage.MEMBER_USER);
    if(memberUserValue !== null){
        return JSON.parse(atob(memberUserValue))
    }
}

const fetchMemberUser = async (authConfig) => {
    const token = await getBearerToken();
    const userId = await getUserId();
    const response = await fetch(`${authConfig.memberUserUri}/${userId}`, {
        headers: {
            authorization: `Bearer ${token}`,
            'Api-Version': '1'
        }
    });
    return await response.json();
}

export { isAuthenticated, getUser, logout }
